//==========================Pre-loader=======================//
$(document).ready(function(){
	window.ajax_cart = true;
  	jQuery(window).load(function() { jQuery(".ttloader").fadeOut("slow"); });
});

//==========================back-to-top=======================//
$(window).scroll(function() {
if ($(this).scrollTop() > 500) {
$('.top_button').fadeIn(500);
} else {
$('.top_button').fadeOut(500);
}
});	
$('.top_button').click(function(event) {
event.preventDefault();	
$('html, body').animate({scrollTop: 0}, 800);
});

//==================== category toggle ====================//
$(document).ready(function(){
	$(".header-bottom .categories_title").click(function(){
	$(".header-bottom #CategoryBox #SiteCat").slideToggle(800);
	$('.header-bottom .categories_title').toggleClass('active'); 
	});
});

//==================== account toggle ====================//
$(document).ready(function(){
	$(".account-block").click(function(){
	$(".tm_header-dropdown .my-account").slideToggle(500);
	$('.tm_header-dropdown').toggleClass('active'); 
	});
});


//==================== cart toggle ====================//
$(document).ready(function(){
	$(".cart-text_block").click(function(){
	$(".site-header__cart .cart-content.block").slideToggle(500);
	$('.site-header__cart').toggleClass('active'); 
	});
});


//==================== currency toggle ====================//
$(document).ready(function(){
	$(".currency-title").click(function(){
	$(".currency .currency-menu").slideToggle(500);
	$('.currency').toggleClass('active'); 
	});
});


//====================== collection tab =======================//
$(document).ready(function() {
    $('.product_tab-block ul.tabs').each(function(){
      var active, content, links = $(this).find('a');
      active = links.first().addClass('active');
      content = $(active.attr('href'));
      links.not(':first').each(function () {
        $($(this).attr('href')).hide();
      });
      $(this).find('a').click(function(e){
        active.removeClass('active');
        content.hide();
        active = $(this);
        content = $($(this).attr('href'));
        active.addClass('active');
        content.show();
        return false;
      });
    });
  });


/*=====================  More site navigation =======================*/
function more_left() {
  if ($(window).width() > 1439){
    var max_elem = 7;
    var items = $('.header-top #AccessibleNav #SiteNav > li');
    var surplus = items.slice(max_elem, items.length);
    surplus.wrapAll('<li class="more-site-nav hiden_menu"><div class="site-nav__dropdown"><ul>');
    $('.header-top .hiden_menu').prepend('<a class="site-nav__link site-nav__link--main" href="#">more</a>')
  }
  else if ($(window).width() > 1269){
    var max_elem = 5;
    var items = $('.header-top #AccessibleNav #SiteNav > li');
    var surplus = items.slice(max_elem, items.length);
    surplus.wrapAll('<li class="more-site-nav hiden_menu"><div class="site-nav__dropdown"><ul>');
    $('.header-top .hiden_menu').prepend('<a class="site-nav__link site-nav__link--main" href="#">more</a>')
  }
  else {
    var max_elem = 4;
    var items = $('.header-top #AccessibleNav #SiteNav > li');
    var surplus = items.slice(max_elem, items.length);
    surplus.wrapAll('<li class="more-site-nav hiden_menu"><div class="site-nav__dropdown"><ul>');
    $('.header-top .hiden_menu').prepend('<a class="site-nav__link site-nav__link--main" href="#">more</a>')
  }
}
$(document).ready(function() {
    more_left()
});

//======================== Sticky header ======================//
function StickyHeader(){	
	"use strict";	
	var num = 115; //number of pixels before modifying styles
	
		jQuery(window).bind('scroll', function () {
			if (jQuery(window).scrollTop() > num) {
				jQuery('.header-fix').addClass('sticky-menu');
				jQuery('.site-header-fix').addClass('header-style');
				jQuery('.category-box').addClass('home-category-fix');
				jQuery('.home-category').addClass('home-category-fix1');
				
			} else {
				jQuery('.header-fix').removeClass('sticky-menu');		
				jQuery('.site-header-fix').removeClass('header-style');
				jQuery('.category-box').removeClass('home-category-fix');
			}
		})
}
jQuery(document).ready(function() { "use strict";   StickyHeader()});
jQuery(window).resize(function() {  "use strict";   StickyHeader()});

//====================== collection tab =======================//
$(document).ready(function() {
    $('.product-single__description ul.tabs').each(function(){
      var active, content, links = $(this).find('a');
      active = links.first().addClass('active');
      content = $(active.attr('href'));
      links.not(':first').each(function () {
        $($(this).attr('href')).hide();
      });
      $(this).find('a').click(function(e){
        active.removeClass('active');
        content.hide();
        active = $(this);
        content = $($(this).attr('href'));
        active.addClass('active');
        content.show();
        return false;
      });
    });
  });


/*==================sidebar toggle====================*/
function mobileToggleColumn1(){
  if ($(window).width() < 990){
    $(".side-bar h3.box-heading").append( "<span class='mobile_togglemenu'> </span>" );  
    $(".side-bar h3.box-heading").addClass('toggle');
    $(".side-box .mobile_togglemenu").click(function(){
       $(this).parent().toggleClass('active').parent().find('.box-content').slideToggle('slow');
    });    
  }
  else{
    $(".side-bar h3.box-heading").removeClass('toggle');
    $(".side-bar h3.box-heading").removeClass('active');
    $(".side-box .mobile_togglemenu").remove();
  }
}
$(document).ready(mobileToggleColumn1);


/*==================footer toggle====================*/
function mobileToggleColumn(){
  if ($(window).width() < 990){
    $(".site-footer .footer-box  h5").append( "<span class='mobile_togglemenu'> </span>" );  
    $(".site-footer .footer-box h5").addClass('toggle');
    $(".footer-box .mobile_togglemenu").click(function(){
       $(this).parent().toggleClass('active').parent().find('.footer-content').slideToggle('slow');
    });    
  }
  else{
    $(".site-footer .footer-box  h5").removeClass('toggle');
    $(".site-footer .footer-box h5").removeClass('active');
    $(".footer-box .mobile_togglemenu").remove();
  }
}
$(document).ready(mobileToggleColumn);

//======================mobile menu toogle======================//
$(document).ready(function(){

 
  $("#MobileNav .mobile-nav__dropdown").parent().append("<span class='mobile_togglecolumn'></span>");
        $('#MobileNav .mobile_togglecolumn').click(function () {
            $(this).parent().toggleClass('active');
        });
  
   $("#MobileNav .mobile-nav__grand_dropdown").parent().append("<span class='mobile_togglecolumn'></span>");
        $('#MobileNav .mobile-nav__grand__item .mobile_togglecolumn').click(function () {
            $(this).parent().toggleClass('active');
        });
 		
});

/*================== sidebar category-box ===================*/
function mobileToggleMenu10(){
    $(".side-bar #CategoryBox  ul#SiteCat > li.site-cat--has-dropdown").append( "<span class='mobile_togglemenu'> </span>" );  
    $(".side-bar #CategoryBox  ul#SiteCat > li.site-cat--has-dropdown").addClass('toggle');
    $(".side-bar #CategoryBox  ul#SiteCat > li.site-cat--has-dropdown .mobile_togglemenu").click(function(){
       $(this).parent().toggleClass('active').find('.site-nav__dropdown').slideToggle('slow');    
    });    
}
$(document).ready(mobileToggleMenu10);

function mobileToggleMenu11(){
    $(".side-bar #CategoryBox  ul#SiteCat  li.site-cat--has-dropdown .site-nav__childlist-item-dropdown").append( "<span class='mobile_togglemenu'> </span>" );  
    $(".side-bar #CategoryBox  ul#SiteCat li.site-cat--has-dropdown .site-nav__childlist-item-dropdown").addClass('toggle'); 
    $(".side-bar #CategoryBox  ul#SiteCat li.site-cat--has-dropdown .site-nav__childlist-item-dropdown .mobile_togglemenu").click(function(){
       $(this).parent().toggleClass('active').find('.grand-child-has-dropdown').slideToggle('slow'); 
    });    
}
$(document).ready(mobileToggleMenu11);


//------------------------------ Responsive left column------------------//
function responsivecolumn()
{
	if ($(document).width() <= 990)
	{
		$('.main-content .page-width.contents .side-bar').insertAfter('.main-content .page-width.contents .main-container');
	}
}
$(document).ready(function(){responsivecolumn(); });
$(window).resize(function(){responsivecolumn(); });

// ---------------- start more menu setting ----------------------
/* JS for More link in Sidebar Category block */
    jQuery(document).ready(function(){
        'use strict';
        let surplus;
        let items;
        let maxelem = 0;
        maxelem = 9;
        $('.header-bottom .category_box .site-cat > li.site-cat-item').first().addClass('home_first');
        items = $('.header-bottom .category_box .site-cat > li.site-cat-item');
        surplus = items.slice(maxelem, items.length);
        surplus.wrapAll('<li class="site-cat-item site-cat--has-dropdown cat-parent hiden_menu"><ul class="children site-nav__dropdown">');
        $('.header-bottom .category_box .site-cat .hiden_menu').prepend('<a href="#" class="site-cat__link site-cat__link--main activSub">More</a>');
    });


/* JS for Sidebar Category block */
// ------------------------------------------------------

$(document).ready(function(){
  if ($(window).width() < 990){
	$(".mobile-nav-title").click(function(){
	$('.category_box').toggleClass('open'); 
	}); 
  }
});

$(document).ready(function(){
	$(".close-menu").click(function(){
	$('.category_box').removeClass('open'); 
	}); 
});


//============================ search toggle ==============================//
$(document).ready(function(){
	$(".header-search-btn").click(function(){
	$(".search-header").slideToggle(300); 
    $('.header-search-btn').toggleClass('active'); 
	});
});


//=================================== Thumbnail product carousel ========================================//
$('#thumbnail-carousel.owl-carousel').owlCarousel({
    loop:true,
    margin: 10,
    nav:true,
  	dots: false,
    autoplay: true,
    responsive:{
        0:{
            items:3
        },
      	480:{
            items:3
        },
      	600:{
            items:4
        },
        750:{
            items:3
        },
        1000:{
            items:3
        }
    }
})


//================================= Related Product carousel ==================================//
$('#related_products_slider').on('changed.owl.carousel initialized.owl.carousel', function(event) {
    $(event.target)
      .find('.owl-item').removeClass('last')
      .eq(event.item.index + event.page.size - 1).addClass('last');
  }).owlCarousel({
    loop:true,
  	margin:10,
    nav:true,
  	dots: false,
    responsive:{
        0:{
            items:2
        },
        551:{
            items:3
        },
      	991:{
            items:4
        },
        1271:{
            items:5
        }
    }
})

$('#related_products_slider.owl-carousel').find('.owl-nav').removeClass('disabled');


//=================================== Insert after ========================================//

// if ($(document).width() >= 1270) {
// 	$( ".blog-container" ).insertAfter( $( ".singel_cat_cms" ) );
// }

//=================================== category list carousel ========================================//
$('.collection-list .owl-carousel').owlCarousel({
    loop:true,
    margin:10,
    nav:false,
  	dots: false,
    autoplay: true,
    responsive:{
        0:{
            items:2
        },
      	480:{
            items:3
        },
      	750:{
            items:4
        },
        990:{
            items:5
        },
        1270:{
            items:7
        }
    }
})

//================================= Product collection-3 carousel ==================================//
$('.collection-3 .slider').on('changed.owl.carousel initialized.owl.carousel', function(event) {
    $(event.target)
      .find('.owl-item').removeClass('last')
      .eq(event.item.index + event.page.size - 1).addClass('last');
  }).owlCarousel({
    loop:true,
    nav:true,
  	dots: false,
    responsive:{
        0:{
            items:2
        },
      	551:{
            items:3
        },
        750:{
            items:2
        },
      	990:{
            items:3
        },
        1271:{
            items:4
        }
    }
})

//================================= Product collection-2 carousel ==================================//
$('.collection-2 .slider').on('changed.owl.carousel initialized.owl.carousel', function(event) {
    $(event.target)
      .find('.owl-item').removeClass('last')
      .eq(event.item.index + event.page.size - 1).addClass('last');
  }).owlCarousel({
    loop:true,
    nav:true,
  	dots: false,
    responsive:{
        0:{
            items:2
        },
      	551:{
            items:3
        },
        750:{
            items:2
        },
      	990:{
            items:3
        },
        1271:{
            items:4
        }
    }
})

//================================= Product collection-1 carousel ==================================//
$('.collection-1 .slider').on('changed.owl.carousel initialized.owl.carousel', function(event) {
    $(event.target)
      .find('.owl-item').removeClass('last')
      .eq(event.item.index + event.page.size - 1).addClass('last');
  }).owlCarousel({
    loop:true,
    nav:true,
  	dots: false,
    responsive:{
        0:{
            items:2
        },
      	551:{
            items:3
        },
        750:{
            items:2
        },
      	990:{
            items:3
        },
        1270:{
            items:4
        }
    }
})


//================================= Product fullwidth carousel ==================================//
$('.slider').on('changed.owl.carousel initialized.owl.carousel', function(event) {
    $(event.target)
      .find('.owl-item').removeClass('last')
      .eq(event.item.index + event.page.size - 1).addClass('last');
  }).owlCarousel({
    loop:true,
    nav:true,
  	dots: false,
    responsive:{
        0:{
            items:2
        },
        551:{
            items:3
        },
      	750:{
            items:3
        },
      	990:{
            items:4
        },
        1270:{
            items:5
        }
    }
})


//================================= blog carousel ==================================//
$('#blog_slider.owl-carousel').owlCarousel({
    loop:true,
    margin:10,
    nav:true,
  	dots: false,
    responsive:{
        0:{
            items:1
        },
        990:{
            items:2
        },
        1270:{
            items:2
        }
    }
})


//================================= brand carousel ==================================//
$('#brand-slider.owl-carousel').owlCarousel({
    loop:true,
    nav:false,
  	dots: false,
    autoplay: true,
    responsive:{
        0:{
            items:2
        },
      	480:{
            items:3,
          	margin:10,
        },
        750:{
            items:4,
          	margin:10,
        },
      	990:{
            items:5,	
          	margin:10,
        },
        1270:{
            items:7,	
          	margin:10,
        }
    }
})


/*================== category-box ===================*/
function mobileToggleMenu2(){
  if ($(window).width() < 990){
    $("#CategoryBox  ul#SiteCat > li.site-cat--has-dropdown").append( "<span class='mobile_togglemenu'> </span>" );  
    $("#CategoryBox  ul#SiteCat > li.site-cat--has-dropdown").addClass('toggle');
    $("#CategoryBox  ul#SiteCat > li.site-cat--has-dropdown .mobile_togglemenu").click(function(){
       $(this).parent().toggleClass('active').find('.site-nav__dropdown').slideToggle('slow');
       
    });    
  }
  else
  {
    $("#CategoryBox  ul#SiteCat > li.site-cat--has-dropdown").removeClass('toggle')
    $("#CategoryBox  ul#SiteCat > li.site-cat--has-dropdown").removeClass('active');
    $("#CategoryBox  ul#SiteCat > li.site-cat--has-dropdown .mobile_togglemenu").remove();
  }
}
$(document).ready(mobileToggleMenu2);

function mobileToggleMenu3(){
  if ($(window).width() < 990){
    $(" #CategoryBox  ul#SiteCat  li.site-cat--has-dropdown .site-nav__childlist-item-dropdown").append( "<span class='mobile_togglemenu'> </span>" );  
    $(" #CategoryBox  ul#SiteCat li.site-cat--has-dropdown .site-nav__childlist-item-dropdown").addClass('toggle');
    $(" #CategoryBox  ul#SiteCat li.site-cat--has-dropdown .site-nav__childlist-item-dropdown .mobile_togglemenu").click(function(){
       $(this).parent().toggleClass('active').find(' .grand-child-has-dropdown').slideToggle('slow');
       
    });    
  }
  else
  {
    $("#CategoryBox  ul#SiteCat  li.site-cat--has-dropdown .site-nav__childlist-item-dropdown").removeClass('toggle')
    $("#CategoryBox  ul#SiteCat  li.site-cat--has-dropdown .site-nav__childlist-item-dropdown").removeClass('active');
    $("#CategoryBox  ul#SiteCat  li.site-cat--has-dropdown .site-nav__childlist-item-dropdown .mobile_togglemenu").remove();
  }
}
$(document).ready(mobileToggleMenu3);

/*================== sidebar category-box ===================*/
function mobileToggleMenu4(){
    $(".side-bar #CategoryBox  ul#SiteCat > li.site-cat--has-dropdown").append( "<span class='mobile_togglemenu'> </span>" );  
    $(".side-bar #CategoryBox  ul#SiteCat > li.site-cat--has-dropdown").addClass('toggle');
    $(".side-bar #CategoryBox  ul#SiteCat > li.site-cat--has-dropdown .mobile_togglemenu").click(function(){
       $(this).parent().toggleClass('active').find('.site-nav__dropdown').slideToggle('slow');    
    });    
}
$(document).ready(mobileToggleMenu4);

function mobileToggleMenu5(){
    $(".side-bar #CategoryBox  ul#SiteCat  li.site-cat--has-dropdown .site-nav__childlist-item-dropdown").append( "<span class='mobile_togglemenu'> </span>" );  
    $(".side-bar #CategoryBox  ul#SiteCat li.site-cat--has-dropdown .site-nav__childlist-item-dropdown").addClass('toggle'); 
    $(".side-bar #CategoryBox  ul#SiteCat li.site-cat--has-dropdown .site-nav__childlist-item-dropdown .mobile_togglemenu").click(function(){
       $(this).parent().toggleClass('active').find('.grand-child-has-dropdown').slideToggle('slow'); 
    });    
}
$(document).ready(mobileToggleMenu5);
